import { createActions, createReducer } from 'reduxsauce';
import { IDownloadBarProps } from 'components/DownloadBar/interface';

export const { Types, Creators } = createActions({
  openDownloadBar: ['data'],
  closeDownloadBar: []
});

const INITIAL_STATE: IDownloadBarProps = {
  show: false,
  url: undefined,
  state: {},
};

const openDownloadBar = (state = INITIAL_STATE, action: any) => ({
  ...action.data,
   show: true
});

const closeDownloadBar = (state = INITIAL_STATE, action: any) => ({
  url: undefined
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_DOWNLOAD_BAR as any]: openDownloadBar,
  [Types.CLOSE_DOWNLOAD_BAR as any]: closeDownloadBar
});
